import { useDispatch, useSelector } from "react-redux";
import { clearDataOnLogout } from "../../utils/utils";
import { Navigate, Outlet } from "react-router-dom";


const ProtectedRoute = () => {
  const customer = useSelector((state) => state.auth.accessifyCustomer);
  const dispatch = useDispatch();

  if (!customer) {
    return <Navigate to="/auth" />;
  }

  const expireTime = new Date(customer.sessionExpireTime).getTime();
  if (Date.now() > expireTime) {
    clearDataOnLogout(dispatch);
    return <Navigate to="/auth" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;